<template>
<div class="row lecture_display">
    <h6>
        <b>My Class Page</b>
    </h6>
    <br />
    <div class="row">
        <div class="col s2">
            <br />
            <b>Chapter -</b>
        </div>
        <div class="col l2 m4 s10 offset-l1 offset-m1">
            <select @change="onChange($event)" v-model="current_chapter">
                <option v-for="item in chapters" :value="item.chapter_id">{{ item.chapter_id }}</option>
            </select>
        </div>
    </div>
    <div class="lecture_item" v-for="item in data.lectures">
        <router-link :to="'/lecture/'+item.id">
            <div class="row item">
                <div class="col l4 m6 s6 offset-s3">
                    <img v-if="item.link" src="https://cdn.vox-cdn.com/thumbor/HIluJzxPz3qH66lFxxHKVl10UzQ=/0x0:2040x1360/1200x800/filters:focal(857x517:1183x843)/cdn.vox-cdn.com/uploads/chorus_image/image/60211577/acastro_180403_1777_youtube_0001.0.jpg" alt />
                    <img v-else src="https://previews.123rf.com/images/unitonevector/unitonevector1904/unitonevector190402904/121580945-training-concept-banner-vector-illustration-business-man-teacher-giving-employee-person-lecture-or-p.jpg" alt />
                </div>
                <div class="col l8 m6 s12">
                    <p>{{ item.name }}</p>
                </div>
            </div>
        </router-link>
    </div>
</div>
</template>

<script>
export default {
    computed: {
        data() {
            return this.$store.getters.each_subject;
        },
        chapters() {
            return this.$store.getters.chapters;
        },
        current_chapter() {
            return this.$store.getters.current_chapter;
        }
    },
    mounted() {
        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems, {});
    },
    updated() {
        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems, {});
    },
    methods: {
        onChange(e) {
            this.$store.dispatch("get_subject", {
                id: this.$route.params.id,
                chapter_id: e.target.value
            });
        }
    }
};
</script>

<style lang="scss">
.lecture_display {
    padding-top: 10px;
}

.lecture_item .item {
    border-bottom: 3px solid black;
    margin-bottom: 20px;

    img {
        width: 100%;
        height: 100px;
    }
}
</style>
